import { createFileRoute, Outlet } from "@tanstack/react-router";
import type { FC } from "react";
import { showQuotationBatch } from "../../../../../__generated__/orval/endpoints/quotation-batches/quotation-batches";
import { ForbiddenError } from "../../../../../errors/ForbiddenError";

const RouteComponent: FC = () => {
  return <Outlet />;
};

export const Route = createFileRoute(
  "/_private/vbuyer/quotation_batches/$quotationBatchId",
)({
  beforeLoad({ context }) {
    if (context.auth.user?.roles_names.includes("View Quotation Batches")) {
      return;
    }

    throw new ForbiddenError();
  },
  component: RouteComponent,
  loader: ({ params: { quotationBatchId } }) =>
    showQuotationBatch(parseInt(quotationBatchId, 10)),
});
